import { render, staticRenderFns } from "./UiSetting.vue?vue&type=template&id=056ee8e8&scoped=true&"
import script from "./UiSetting.vue?vue&type=script&lang=js&"
export * from "./UiSetting.vue?vue&type=script&lang=js&"
import style0 from "./UiSetting.vue?vue&type=style&index=0&id=056ee8e8&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "056ee8e8",
  null
  
)

export default component.exports